import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { NbToastrService } from '@nebular/theme';
import { RxFormBuilder } from '@rxweb/reactive-form-validators';
import { TblActionType } from 'src/app/shared/enums/tbl-action-type.enum';
import { ComputedProposalArtist, NormalizedProposalArtists, ProposalArtists, ProposalArtistLineItem } from '../../../opportunity.model';
import { DatastateManagementService } from 'src/app/modules/admin/datastate-management/datastate-management.service';
import { DropDownValue } from 'src/app/modules/admin/summary-report/summary-report.component';
import { DropDownGroups } from 'src/app/shared/interfaces/dropdown-group';
import { OpportunityManagementService } from '../../../opportunity-management.service';
import { ProfileDetailModel } from 'src/app/modules/admin/profile-management/profile-detail.model';
import { Helper } from 'src/app/shared/utility/Helper';
import { SettingPoolService } from 'src/app/shared/services/setting-pool.service';
import { environment } from 'src/environments/environment';
import { QuillConfiguration } from 'src/app/shared/components/stand-alone-component/rich-inline-edit/rich-inline-edit.component';
import { SettingService } from 'src/app/shared/services/setting.service';

@Component({
  selector: 'app-add-edit-artist',
  templateUrl: './add-edit-artist.component.html',
  styleUrls: ['./add-edit-artist.component.scss']
})
export class AddEditArtistComponent implements OnInit {

  action: TblActionType;
  frm: FormGroup;
  isLoading = false;
  dataModel: ComputedProposalArtist;
  color1: string = '#2889e9';
  statusLst: DropDownValue[] = [];
  //tasktemplateLst: TaskTemplateModel[] = [];
  //taskscriptGroupLst: TaskScriptGroupModel[] = [];
  environment = environment;
  editorOptions = QuillConfiguration
  total: number = 0;
  totalMath: string;
  defaultArtistDatastate: string;

  constructor(
    public dialModalRef: MatDialogRef<AddEditArtistComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private frmBuilder: RxFormBuilder,
    private toast: NbToastrService,
    private cdref: ChangeDetectorRef,
    public automatService: DatastateManagementService,
    public opportunityService: OpportunityManagementService,
    public settingService: SettingService,
    private dialog: MatDialog,
  ) {
    this.action = data.action;
    this.dataModel = data.model ?? new ComputedProposalArtist();
    if (this.action == TblActionType.Add) {
      this.dataModel.id = 0;
    }
    this.total = this.dataModel.total;
  }

  feeItems: ProposalArtistLineItem[] = [];

  ngOnInit(): void {
    // try to set default value
    if (this.dataModel && (this.dataModel.quantity == null || this.dataModel.quantity == undefined)) {
      this.dataModel.quantity = 1;
    }
    this.feeItems = this.dataModel.feeItems ? [...this.dataModel.feeItems] : [];
    this.frm = this.frmBuilder.formGroup(ComputedProposalArtist, Helper.convertNumberPropertiesToString(this.dataModel));
    this.dialModalRef.updatePosition({ right: '0' });
    this.getTotalMath();
    this.getStatusLst();
  }
  get totalItemsCost(): number {
    return (this.feeItems || []).reduce((sum, item) => sum + (item.cost || 0), 0);
  }

  get totalItemsClientFee(): number {
    return (this.feeItems || []).reduce((sum, item) => sum + (item.clientFee || 0), 0);
  }

  get totalClientFeeCombined(): number {
    const estClientFee = parseFloat(this.frm?.get('estTotalClientFee')?.value || 0);
    return estClientFee + this.totalItemsClientFee;
  }

  async getTotalMath() {
    const rs = await this.settingService.getSettingByKeyAndGroup("TOTAL_OPPORTUNITY_ARTIST_MATH", "SALE_CONFIG").toPromise();
    if (rs.result && rs.result.value) {
      this.totalMath = rs.result.value;
    }

    this.registerValueChangeEvent();
  }

  registerValueChangeEvent() {
    this.frm.valueChanges.subscribe(e => {
      try {
        const qty = parseFloat(e.quantity || 0);
        const artFee = parseFloat(e.artistFee || 0);
        const cliFee = parseFloat(e.feeToClient || 0);

        const estTotalArtistFee = artFee * qty;
        const estTotalClientFee = cliFee * qty;

        this.frm.patchValue({
          estTotalArtistFee: estTotalArtistFee,
          estTotalClientFee: estTotalClientFee
        }, { emitEvent: false });

        const pascalObj = Helper.toPascalCase(e);
        pascalObj['EstTotalArtistFee'] = estTotalArtistFee;
        pascalObj['EstTotalClientFee'] = estTotalClientFee;

        const mergeTagMath = Helper.handleMergeTag(this.totalMath, pascalObj);
        this.total = eval(mergeTagMath);
      }
      catch (ex) {
        this.total = 0;
      }
    });
  }
  async getStatusLst() {
    try {
      const res = await this.automatService.getAutomateDataState('PROPOSAL_ARTIST').toPromise();
      if (!res.message) {
        this.statusLst = res.result.map(e => { return { value: e.automateDataStateId.toString(), text: e.dataStateName, color: e.colorCode } });
        if (this.action === TblActionType.Add) {
          if (this.data?.model?.isFromProfile) {
            const proposedId = await this.settingService.getSettingByKeyAndGroup("PROPOSAL_ARTIST_PROPOSED_ID", "SALE_CONFIG").toPromise();
            if (proposedId.result) {
              this.frm.controls.automateDataState.patchValue(proposedId.result.value);
            }
          }
          else {
            let defaultArtistDatastateId = await this.settingService.getSettingByKeyAndGroup("DEFAULT_ARTIST_AUTOMATE_DATA_STATE", "PROFILE").toPromise();
            if (defaultArtistDatastateId?.result) {
              this.frm.controls.automateDataState.patchValue(defaultArtistDatastateId?.result?.value);
            }
          }
        }
      }
    }
    catch (ex) {
      console.log(ex);
    }
  }
  ngAfterContentChecked() {
    this.cdref.detectChanges();
  }

  closeDialog() {
    this.dialModalRef.close();
  }

  async saveData() {
    if (this.frm.valid) {
      const formValue = this.frm.value;
      
      // Use NormalizedProposalArtists class with safe defaults for required fields
      const normalizedModel = new NormalizedProposalArtists(formValue);
      normalizedModel.feeItems = this.feeItems;

      const saveProposal = await this.opportunityService.saveProposalArtist(normalizedModel).toPromise();
      if (saveProposal.result) {
        this.toast.success("", "Saved successfully");
        this.dialModalRef.close(true);
      }
      else {
        this.toast.danger("", "Saved failed")
      }
    }
  }
  selectPID(data: any) {
    this.frm.controls.profileId.patchValue(data?.profileId || data);
  }
  selectProposal(data: ProfileDetailModel) {
    this.frm.controls.proposalId.patchValue(data.profileId);
  }

  addLineItem() {
    const dialogRef = this.dialog.open(EditArtistLineItemModalComponent, {
      width: '550px',
      data: { item: { cost: 0, clientFee: 0, visibleToClient: false, sortOrder: this.feeItems.length } }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.feeItems.push(result);
        this.updateFeeItemsControl();
      }
    });
  }

  editLineItem(item: any, index: number) {
    const dialogRef = this.dialog.open(EditArtistLineItemModalComponent, {
      width: '550px',
      data: { item: { ...item } }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.feeItems[index] = result;
        this.updateFeeItemsControl();
      }
    });
  }

  deleteLineItem(index: number) {
    this.feeItems.splice(index, 1);
    this.updateFeeItemsControl();
  }

  updateFeeItemsControl() {
    this.frm.markAsDirty();
    this.frm.patchValue(this.frm.value, { emitEvent: true });
  }

  getCurrencySymbol(): string {
    return localStorage.getItem('currency') || '$';
  }

  formatCurrencyText(val: any): string {
    const numericVal = parseFloat(val);
    if (isNaN(numericVal)) return `${this.getCurrencySymbol()}0.00`;
    const formatted = new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(numericVal);
    return `${this.getCurrencySymbol()}${formatted}`;
  }
}

@Component({
  selector: 'app-edit-artist-line-item-modal',
  template: `
    <div class="d-flex flex-wrap shadow-sm bg-light py-2 px-3 align-items-center" mat-dialog-title style="margin: unset;">
        <h5 class="m-0 font-weight-bold" style="font-size: 16px; color: #333;">Edit Line Item</h5>
        <button mat-button color="primary" (click)="save()" [disabled]="!frm?.valid" class="ml-auto mr-1">
            <mat-icon fontSet="material-icons-outlined">save</mat-icon>Save
        </button>
        <button mat-button color="warn" (click)="cancel()">
            <mat-icon fontSet="material-icons-outlined">clear</mat-icon>Cancel
        </button>
    </div>
    <mat-divider></mat-divider>
    <mat-dialog-content class="mat-typography" style="padding-top: 15px;">
        <form [formGroup]="frm" class="container">
            <div class="row">
                <div class="col-12">
                    <mat-form-field appearance="standard" class="w-100">
                        <mat-label>Item Name</mat-label>
                        <input matInput autocomplete="off" formControlName="name" required placeholder="e.g. Flight ticket">
                        <mat-error *ngIf="frm.controls.name.errors && (frm.controls.name.dirty || frm.controls.name.touched)">Name is required</mat-error>
                    </mat-form-field>
                </div>
                <div class="col-12">
                    <mat-form-field appearance="standard" class="w-100">
                        <mat-label>Description</mat-label>
                        <textarea matInput autocomplete="off" formControlName="description" rows="2" placeholder="Optional details..."></textarea>
                    </mat-form-field>
                </div>
                <div class="col-6">
                    <mat-form-field appearance="standard" class="w-100">
                        <mat-label>Cost</mat-label>
                        <input matInput type="number" autocomplete="off" formControlName="cost" required>
                    </mat-form-field>
                </div>
                <div class="col-6">
                    <mat-form-field appearance="standard" class="w-100">
                        <mat-label>Client Fee</mat-label>
                        <input matInput type="number" autocomplete="off" formControlName="clientFee" required>
                    </mat-form-field>
                </div>
                <div class="col-12 mt-3 mb-2">
                    <mat-checkbox formControlName="visibleToClient">Visible to client</mat-checkbox>
                </div>
            </div>
        </form>
    </mat-dialog-content>
  `
})
export class EditArtistLineItemModalComponent implements OnInit {
  frm: FormGroup;

  constructor(
    public dialModalRef: MatDialogRef<EditArtistLineItemModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder
  ) {}

  ngOnInit() {
    const item = this.data?.item || {};
    this.frm = this.fb.group({
      name: [item.name || '', Validators.required],
      description: [item.description || ''],
      cost: [item.cost || 0],
      clientFee: [item.clientFee || 0],
      visibleToClient: [item.visibleToClient || false],
      sortOrder: [item.sortOrder || 0]
    });
  }

  save() {
    if (this.frm.valid) {
      this.dialModalRef.close(this.frm.value);
    }
  }

  cancel() {
    this.dialModalRef.close();
  }
}
